// Vendor Libs
import React from 'react';

// Components
import Loading from '../core/loading';
import Permissions from '../core/permissions';
import AdInsertionConfigForm from './ad-insertion-form';

// Containers
import FormData from '../../containers/form-data';

const formName = 'adInsertionConfig';

const AdInsertionConfig = () => (
    <Permissions
        accessRequirement="update"
        elementService="vfb"
        notAuthorizedMessage={true}
        requiresServiceAccess={true}
    >
        <FormData formName={formName}>
            {({resetForm, searchFetching}) => (
                <>
                    <AdInsertionConfigForm
                        {...{
                            className: 'ad-insertion-config',
                            editing: true,
                            onReset: (submitted, resetValues) => resetForm(submitted, resetValues, true),
                        }}
                    />
                    <Loading loading={searchFetching} />
                </>
            )}
        </FormData>
    </Permissions>
);

export default AdInsertionConfig;
